import { Controller } from "@hotwired/stimulus"

// Scrolls the week/day time grid to the start of the working day.
//
// The grid renders all 24 hours so nothing can fall outside a fixed window; without this
// it would open at midnight and every real appointment would be below the fold.
export default class extends Controller {
  static targets = ["scroller"]
  static values = { scrollHour: { type: Number, default: 7 } }

  connect() {
    if (!this.hasScrollerTarget) return

    const scroller = this.scrollerTarget
    const body = scroller.firstElementChild
    if (!body) return

    const offset = (body.offsetHeight / 24) * this.scrollHourValue
    // Leave the scroll where the user put it when the frame re-renders under them.
    scroller.scrollTop = Math.min(offset, scroller.scrollHeight - scroller.clientHeight)
  }
}
